module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYAgMAAABl+S6cAAAACVBMVEUAAAAWsToWsTrHpKiuAAAAAnRSTlMAxOqay5EAAAAWSURBVAjXY0hhYADiFUByxcCSEJcAAJCIHnFQ5LU1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_pause.png
// module id = 596
// module chunks = 1 7